<template>
  <div class="community">
    <PreContentHeader :show-loading="!contentReady" :error-message="contentLoadError"></PreContentHeader>
    <transition name="fade">
      <div v-if="contentReady && contentLoadError === ''">
        <ContentHeader :name="community.title.rendered"></ContentHeader>
        <div v-html="community.content.rendered"></div>
        <p>See all the Idea challenges and Award events for the {{community.title.rendered}} community:</p>
        <h3>Idea Challenges</h3>
        <section v-if="ideaChallengesActive.length > 0">
          <b-card-group deck>
            <IdeaChallengeSnippet
              v-for="ideaChallengeA of ideaChallengesActive"
              v-bind:key="ideaChallengeA.id"
              :idea-challenge="ideaChallengeA">
            </IdeaChallengeSnippet>
          </b-card-group>
        </section>
        <section v-if="ideaChallengesActive.length === 0">
          <h5 class="text-black-50 mb-4 text-center">
            <em>There are no active idea challenges for {{community.title.rendered}} at present.<br>
              Check this space again sometime soon.
            </em>
          </h5>
        </section>
        <h3 class="text-white-50 bg-secondary p-3 mb-4">Expired challenges</h3>
        <section v-if="ideaChallengesInactive.length > 0">
          <div class="card-columns">
            <IdeaChallengeSnippet
              v-for="ideaChallengeIA of ideaChallengesInactive"
              v-bind:key="ideaChallengeIA.id"
              :idea-challenge="ideaChallengeIA"
              excerpt="true">
            </IdeaChallengeSnippet>
        </div>
        </section>
        <section v-if="ideaChallengesInactive.length === 0">
          <h5 class="text-black-50 mb-4 text-center">
            <em>There are no expired idea challenges for {{community.title.rendered}}
            </em>
          </h5>
        </section>
        <h3>Awards</h3>
        <section v-if="nominationEventActive.length > 0">
          <div v-for="award in nominationEventActive" v-bind:key="award.id" class="card mb-3">
            <div v-if="award._embedded['wp:featuredmedia']" class="featuredImg">
              <img v-if="award._embedded['wp:featuredmedia'][0].media_details.sizes.full.source_url"
                :src="award._embedded['wp:featuredmedia'][0].media_details.sizes.full.source_url"
                :alt="award._embedded['wp:featuredmedia'][0].alt_text"
                :title="award._embedded['wp:featuredmedia'][0].title.rendered"
              >
            </div>
            <div v-html="award.content.rendered" class="card-body px-3 pb-0"></div>
            <ul class="fa-ul" v-if="award.nomination_event_time_frame.length > 0">
              <li class="h6">
                <span class="fa-li"><i class="fas fa-calendar-alt fa-fw fa-sm text-black-50"></i></span>
                {{award.nomination_event_time_frame[0][0][0].nomination_event_date_from}} -
                {{award.nomination_event_time_frame[0][0][0].nomination_event_date_to}}
              </li>
            </ul>
            <ChildNominationEventsList class="px-3 pb-3" :awards="award.child_nomination_awards[0][0]" name="The awards categories are:"></ChildNominationEventsList>
          </div>
        </section>
        <!--<section v-if="nominationEventActive.length === 0">
          <h5 class="text-black-50 mb-4 text-center">
            <em>There are no VE Awards for {{community.title.rendered}} at present.<br>
              Check this space again sometime soon.
            </em>
          </h5>
        </section>
        <h3 class="text-white-50 bg-secondary p-3 mb-4">Expired awards</h3>
        <section v-if="nominationEventInActive.length > 0">
          <div class="card-columns">
            <div v-for="award in nominationEventInActive" v-bind:key="award.id" class="card mb-3">
              <div v-if="award._embedded['wp:featuredmedia']" class="featuredImg">
                <img v-if="award._embedded['wp:featuredmedia'][0].media_details.sizes.full.source_url"
                  :src="award._embedded['wp:featuredmedia'][0].media_details.sizes.full.source_url"
                  :alt="award._embedded['wp:featuredmedia'][0].alt_text"
                  :title="award._embedded['wp:featuredmedia'][0].title.rendered"
                >
              </div>
              <div class="card-body">
                <h6 class="card-title text-center">{{award.title.rendered}}</h6>
                <ChildNominationEventsList :awards="award.child_nomination_awards[0][0]" name=""></ChildNominationEventsList>
              </div>
            </div>
          </div>
        </section>
        <section v-if="nominationEventInActive.length === 0">
          <h5 class="text-black-50 mb-4 text-center">
            <em>There are no expired VE Awards for {{community.title.rendered}}.
            </em>
          </h5>
        </section>-->
      </div>
    </transition>
  </div>
</template>

<script>
import WordpressRestAPI from '@/helpers/WordpressRestAPI.js'
import ContentHeader from '@/components/ContentHeader'
import IdeaChallenges from '@/components/routes/IdeaChallenges'
import IdeaChallengeSnippet from '@/components/IdeaChallengeSnippet'
import ChildNominationEventsList from '@/components/ChildNominationEventsList'
import PreContentHeader from '@/components/PreContentHeader'
export default {
  components: {
    ContentHeader,
    IdeaChallenges,
    IdeaChallengeSnippet,
    ChildNominationEventsList,
    PreContentHeader
  },
  data () {
    return {
      community: {},
      contentReady: false,
      contentLoadError: '',
      ideaChallengesActive: [],
      ideaChallengesInactive: [],
      nominationEventActive: [],
      nominationEventInActive: []
    }
  },
  methods: {
    loadContent: function () {
      document.title = this.$route.params.name.replace(/-/g, ' ') + ' - ThinkTank'
      WordpressRestAPI.getViewContent('communities?slug=' + this.$route.params.name + '&_embed')
        .then(response => {
          this.community = response.data[0]
          this.loadChallenges()
          this.loadNominationEvents()
          this.contentReady = true
        })
        .catch(e => {
          this.contentLoadError = 'Oops! We had a problem with loading this community. Please try again later.'
          console.error(e)
          this.contentReady = true
        })
    },
    loadChallenges: function () {
      WordpressRestAPI.getViewContent('idea_challenge?_embed&idea_chalenge_category_exclude=10&community_categories=' + this.community.community_categories[0])
        .then(response => {
          this.ideaChallengesActive = response.data.filter(x => !x.idea_chalenge_category.includes(30))
          this.ideaChallengesInactive = response.data.filter(x => x.idea_chalenge_category.includes(30))
        })
        .catch(e => {
          // this.errors.push(e)
        })
    },
    loadNominationEvents: function () {
      WordpressRestAPI.getViewContent('nomination_event?_embed&nomination_event_category=22&community_categories=' + this.community.community_categories[0])
        .then(response => {
          this.nominationEventActive = response.data.filter(x => !x.nomination_event_category.includes(35))
          this.nominationEventInActive = response.data.filter(x => x.nomination_event_category.includes(35))
        })
        .catch(e => {
          // this.errors.push(e)
        })
    }
  },
  created () {
    this.loadContent()
  },
  watch: {
    '$route' (to, from) {
      this.contentReady = false
      this.loadContent()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/routes/Community.vue